import { Injectable } from '@angular/core';
import { WebConfigurationService } from '../common/web-configuration.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Search } from 'src/app/model/search/search.model';

@Injectable({
  providedIn: 'root'
})
export class SearchService extends WebConfigurationService {

  constructor(protected http: HttpClient) {
    super( http );
   }

    /**
   * Get search response
   * @param search  the string typed in search-bar
   * @returns an Observable
   */
     public getSearchData( search : string, page : string ): Observable<Search> {
       console.log(this.getSearchUrl( search, page ))
      return  this.authGetObs<Search>( this.getSearchUrl( search, page ) );
    }

}
